import { jsxs, jsx } from 'react/jsx-runtime';
import { PersonAvatar } from '@sketch/components';
import '../Arrow/index.js';
import { StyledLink, ImageContainer, StyledResponsiveImage, ContentWrapper, Title, Details, Date, Calendar, Time, Location, Pin, Description, Speakers, Speaker, Name, Role, ReadMore } from './Event.styles.js';
import '../../hooks/index.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import Arrow from '../Arrow/Arrow.js';

/**
 *
 * Event
 *
 * This component renders the items for the Events section
 * in the Discover page.
 */
const Event = ({ title, content, image, links, date, place, speakers, }) => {
    // Analytics
    const { trackEvent } = useTrackEvent();
    const { ref } = useTrackEventInView('DISCOVER - Events', {
        type: 'load',
        target: title,
    });
    const link = links === null || links === void 0 ? void 0 : links[0];
    return (jsxs(StyledLink, Object.assign({ target: "_blank", variant: "secondary", href: link === null || link === void 0 ? void 0 : link.url, external: true, isUnderlined: true, onClick: () => trackEvent('DISCOVER - Events', {
            type: 'click',
            target: title,
        }) }, { children: [jsx(ImageContainer, { children: jsx(StyledResponsiveImage, { image: image, withSkeletonUI: true }) }), jsxs(ContentWrapper, Object.assign({ ref: ref }, { children: [jsx(Title, { children: title }), jsxs(Details, { children: [jsxs(Date, { children: [jsx(Calendar, { width: "16px", height: "16px" }), " ", date.day, (date === null || date === void 0 ? void 0 : date.time) && jsxs(Time, { children: ["- ", date === null || date === void 0 ? void 0 : date.time] })] }), jsxs(Location, { children: [jsx(Pin, { width: "16px", height: "16px" }), " ", place] })] }), jsx(Description, { children: content }), jsx(Speakers, { children: speakers === null || speakers === void 0 ? void 0 : speakers.map((speaker, index) => (jsxs(Speaker, { children: [jsx(PersonAvatar, { size: "16px", name: speaker.name, flavour: (speaker === null || speaker === void 0 ? void 0 : speaker.image) ? 'image' : 'color', src: (speaker === null || speaker === void 0 ? void 0 : speaker.image) || '' }, index), jsx(Name, { children: speaker.name }), (speaker === null || speaker === void 0 ? void 0 : speaker.role) && jsxs(Role, { children: ["(", speaker.role, ")"] })] }, index))) }), jsxs(ReadMore, { children: [link === null || link === void 0 ? void 0 : link.text, jsx(Arrow, {})] })] }))] })));
};

export { Event as default };
